import { Theme } from 'config';

const styles = (theme: Theme) => ({
  topHeader: {
    marginTop: '2rem !important',
  },
  grid: {
    backgroundColor: '#fff',
    justifyContent: 'center !important',
    marginTop: '3rem !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.15) !important',
    marginRight: '0 !important',
    marginLeft: '0 !important',
    padding: '1.25rem !important',
  },
  segmentGrid: {
    margin: '0 !important',
  },
  header: {
    color: `${theme.deepPurple} !important`,
    fontSize: '1.35rem !important',
    fontWeight: 'bold',
    textAlign: 'left !important',
    paddingBottom: '.75rem !important',
  },
  dateRow: {
    padding: '0 !important',
  },
  segmentProps: {
    paddingTop: '.25rem !important',
  },
  textLabel: {
    fontSize: '1.1rem',
    marginRight: '.5rem',
    fontWeight: 'bold',
  },
  spacer: {
    paddingRight: '.75rem !important',
    paddingBottom: '.5rem !important',
  },
  container: {
    backgroundColor: '#fff !important',
    borderRadius: '.375rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    margin: '.625rem 0 !important',
    padding: '1.25rem !important',
    width: '100% !important',
    position: 'relative !important',
  },
  segmentList: {
    listStyleType: 'none',
    margin: '0 !important',
    padding: '0 !important',
  },
  segmentListItem: {
    backgroundColor: '#fff !important',
    borderRadius: '.375rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    margin: '1rem 0 !important',
    padding: '1.25rem !important',
    width: '100% !important',

    '&.expired': {
      backgroundColor: `${theme.disabledBtnGray} !important`,
    },
  },
  marketplaceList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    float: 'right',
  },
  button: {
    backgroundColor: `${theme.violet} !important`,
    borderRadius: '1.5em !important',
    color: '#fff !important',
    marginTop: '1rem !important',
    height: '3.125rem',
    fontWeight: 'bold !important',
    width: '100%',
    outline: 0,
    border: 'none !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  buttonSecondary: {
    marginRight: '.45rem !important',
    backgroundColor: `${theme.softGray} !important`,
    color: `${theme.darkGray} !important`,
    height: '3.125rem',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  mediumBtn: {
    width: '48% !important',
  },
  addSegmentButton: {
    backgroundColor: `${theme.violet} !important`,
    borderRadius: '2rem !important',
    color: '#fff !important',
    marginTop: '1rem !important',
    height: '3.125rem',
    fontWeight: 'bold !important',
    outline: 0,
    border: 'none !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  segmentHeader: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  showExpiredOffers: {
    marginTop: '1rem !important',
    '&.ui.toggle.checkbox input:checked ~ label::before': {
      backgroundColor: `${theme.violet} !important`,
    },
  },
});

export default styles;
